import React from 'react';
import './LectureView.less';
import { default as Video, Controls, Overlay } from 'react-html5video';
import Throttle from 'lodash.throttle';
import { observer } from 'mobx-react';
import { withRouter, Link } from 'react-router';
import LecturePlayList from '../../lecture/LecturePlaylist/LecturePlaylist.jsx';
import { Row, Item, Column } from 'react-plan';
import { Scrollbars } from 'react-custom-scrollbars';

type Props = {
  lectures: Object
}

const strings = {
  curriculum: 'Curriculum'
};

const Complete = () => {
  return (
    <Row className="complete card" align="center" justify="center">

      <Item size="100%"><h3 className="txt-center">Congratulations!</h3></Item>
      <Item><img src={ require('../../../img-layout/mission-succes.gif') } alt="Success"/>
      </Item>
      <Item size="100%"><h3 className="txt-center">You completed the lecture.</h3></Item>

    </Row>
  );
};

@observer(['courses', 'lectures', 'enrollments'])
class LectureView extends React.Component {

  description: 'Displays a lecture.'

  props: Props

  constructor(props: Props) {
    super(props);
    this.store = this.props.lectures;
    this.enrollments = this.props.enrollments;
    this.saveProgress = Throttle(this.saveProgress, 1000);
  }

  /* Component Custom Methods */
  handleEnd = (lecture, course) => {
    this.enrollments.completeLecture(lecture, this.props.params.lectureId, course);
  }

  handleProgress = (evt) => {
    evt.persist();
    this.saveProgress(evt);
  }

  saveProgress = (evt) => {
    this.enrollments.updateLecture(this.props.params.lectureId, { elapsed: evt.target.currentTime });
  }

  handleResume = () => {
    const enrollment = this.enrollments.lectures.get(this.props.params.lectureId);
    if (enrollment && enrollment.elapsed) {
      this.refs.video.seek(enrollment.elapsed);
    }
  }
  /* End Component Custom Methods */

  /* React Component LifeCycle Methods */
  componentWillMount() {
    this.store.loadLectureById(this.props.params.lectureId);
  }

  componentDidMount() {
    this.handleResume();
  }

  componentWillReceiveProps(nextProps) {
    //Reload video source and play if the route has changed
    if (nextProps.params.lectureId !== this.props.params.lectureId) {
      this.refs.video.load();
    }
  }

  componentDidUpdate(prevProps) {
    //Resume Video if the route has changed
    if (prevProps.params.lectureId || this.props.param.lectureId) {
      this.handleResume();
    }
  }

  render() {
    const lecture = this.store.lectures.get(this.props.params.lectureId);

    switch (lecture.status) {
      case 404:
        this.props.router.push('/404');
        return null;
      case 200:
        this.props.courses.loadId(lecture.courseId);
        const course = this.props.courses.courses.get(lecture.courseId);
        const enrollment = this.enrollments.lectures.get(this.props.params.lectureId);
        const completed = (enrollment && enrollment.completed) ? <Complete /> : null;
        return (
          <div className="lecture-view">
            <Row className="p-xl content">
              <Row className="bloc-large">
                <Item size="65%" medium="100%" small="100%" className="player">
                  <Video
                    controls={ true }
                    onEnded={ this.handleEnd.bind(this, lecture, course) }
                    onTimeUpdate={ this.handleProgress }
                    poster={ course.cover }
                    ref="video"
                    >
                    <Overlay />
                    <Controls />
                    <source src={ lecture.videoUrl } type="video/mp4" />
                  </Video>
                </Item>
                <Item size="35%" medium="100%" small="100%" className="p-l playlist">
                  <div className="header">
                    <p>This lesson is part of course: </p>
                    <Link className="no-underline" to={ `/course/${lecture.courseId}` }><h4>{ course.name }</h4></Link>
                  </div>
                  <div className="body">
                    <Scrollbars
                      autoHeight={ true }
                      autoHeightMax={ 360 }
                      autoHeightMin={ 200 }
                      renderThumbVertical={ (props) => <div { ...props } className="thumb-vertical" /> }
                    >
                      <LecturePlayList courseId={ lecture.courseId } currentLecture={ this.props.params.lectureId }/>
                    </Scrollbars>
                  </div>
                </Item>
              </Row>
            </Row>
            <div className="m-xl bloc-small">
              { completed }
              <h2 className="text-center">Lecture Description</h2>
              <p className="m-t">{ lecture.description }</p>
            </div>
            <hr />
          </div>
        );
      default:
        return null;
    }
  }
  /* End React Component LifeCycle Methods */
}

export default withRouter(LectureView);

//Unit test entry point
export const LectureViewTest = LectureView;


/** WEBPACK FOOTER **
 ** ./src/js/views/LectureView/LectureView.jsx
 **/